import React, { FunctionComponent } from "react";
import styled from "styled-components";

import { Device } from "@/utils/device";

interface RxContentBlockTitleProps {
  children: React.ReactNode;
  colour?: string;
}

type StyleProps = {
  colour?: string;
};

const RxContentBlockTitle: FunctionComponent<RxContentBlockTitleProps> = (
  props
) => {
  return (
    <S.Title data-cy="content-block-title" colour={props.colour}>
      {props.children}
    </S.Title>
  );
};

const S = () => {};

S.Title = styled.h2<StyleProps>`
  color: ${(p) => p.colour};
  font-size: 2.5rem;
  line-height: 2.8rem;

  @media (min-width: ${Device.mobile}) {
    font-size: 3rem;
    line-height: 3.5rem;
  }

  @media (min-width: ${Device.tablet}) {
    font-size: 3rem;
  }

  @media (min-width: ${Device.desktop}) {
    font-size: 5rem;
    line-height: 4.8rem;
  }
`;

export default RxContentBlockTitle;
